import React from 'react';
import { cn } from '../../lib/utils';

const Progress = React.forwardRef(({ className, value = 0, ...props }, ref) => (
  <div
    ref={ref}
    role="progressbar"
    aria-valuemin={0}
    aria-valuemax={100}
    aria-valuenow={Math.max(0, Math.min(100, value))}
    className={cn('h-2 w-full overflow-hidden rounded-full bg-pearl-200', className)}
    {...props}
  >
    <div
      className="h-full rounded-full bg-primary-900 transition-all duration-300"
      style={{ width: `${Math.max(0, Math.min(100, value))}%` }}
    />
  </div>
));

Progress.displayName = 'Progress';

export { Progress };
